export const farmertotalcat = [
    {
        Categories: "Livestocks",
        soldqty: 2,
        availqty: 7,
        TPM: "N12,390",
        tbcName: "farm-general-tbody",
        tbcIcon: "styletableicon"
     },
     {
        Categories: "Crops",
        soldqty: 2,
        availqty: 7,
        TPM: "N12,390",
        tbcName: "farm-general-tbody",
        tbcIcon: "styletableicon"
     },
     {
        Categories: "Farm Input",
        soldqty: 2,
        availqty: 7,
        TPM: "N12,390",
        tbcName: "farm-general-tbody",
        tbcIcon: "styletableicon"
     },
     {
        Categories: "Processed Products",
        soldqty: 2,
        availqty: 7,
        TPM: "N12,390",
        tbcName: "farm-general-tbody",
        tbcIcon: "styletableicon"
     },
     {
        Categories: "Equipments",
        soldqty: 2,
        availqty: 7,
        TPM: "N12,390",
        tbcName: "farm-general-tbody",
        tbcIcon: "styletableicon"
     }
    ]